// #region Actions
const actions = {
  async createExample({_commit, _dispatch, _state}, {_token}) {
    // ...
  },
};
// #endregion

// #region Getters
const getters = {
  getAgrupar: (state) => state.agrupar,
  getAgruparActualizar: (state) => state.agruparActualizar,
};
// #endregion


// #region Mutations
const mutations = {
  setAgrupar(stateTarget, agrupar) {
    if (!stateTarget.agrupar) {
      stateTarget.agrupar = [];
    }
    const items = Array.isArray(agrupar) ? agrupar : [agrupar];
    stateTarget.agrupar.push(...items);
  },
  setEliminarAgrupar(stateTarget, deleteRegistro) {
    stateTarget.agrupar = stateTarget.agrupar.filter(
      (item) => item.registroId !== deleteRegistro.registroId &&
      item.nivelDestinoId !== deleteRegistro.nivelDestinoId);
  },
  setLimpiarAgrupar(stateTarget) {
    stateTarget.agrupar = [];
  },
  setAgruparActualizar(stateTarget, agruparActualizar) {
    if (!stateTarget.agruparActualizar) {
      stateTarget.agruparActualizar = [];
    }
    stateTarget.agruparActualizar.push(agruparActualizar);
  },
  setEliminarAgruparActualizar(stateTarget, idToDelete) {
    stateTarget.agruparActualizar = stateTarget.agruparActualizar
      .filter((item)=> item.registroId !== idToDelete);
  },
  setLimpiarAgruparActualizar(stateTarget) {
    stateTarget.agruparActualizar = [];
  },
};
// #endregion

// #region State
const stateAgrupar = () => {
  return {
    agrupar: [],
    agruparActualizar: [],
  };
};
// #endregion

// #region Etc
const namespaced = true;
const modules = [];
// #endregion

export default {
  actions,
  getters,
  modules,
  mutations,
  namespaced,
  stateAgrupar,
};
